import { AgentMetricName } from '../../Services/AgentApiProviderTypes';

const compactNumber = new Intl.NumberFormat('en', {
  notation: 'compact',
  maximumFractionDigits: 1,
});

export const formatCount = (value: number) => compactNumber.format(Math.round(value));
export const formatOneDecimal = (value: number) => value.toFixed(1);
export const formatSeconds = (value: number) =>
  value < 10 ? value.toFixed(1) : String(Math.round(value));

export type ExecutionOutcome = 'done' | 'cancelled' | 'failed';

export interface MetricChart {
  metric: AgentMetricName;
  title: string;
  formatValue: (value: number) => string;
  unit?: string;
  integerTicks?: boolean;
  // set on the charts of how executions ended
  outcome?: ExecutionOutcome;
}

// how executions ended, with the icon that goes with each status color
export const OUTCOMES: { metric: AgentMetricName; outcome: ExecutionOutcome; icon: string }[] = [
  { metric: 'done_executions', outcome: 'done', icon: 'fa-circle-check' },
  { metric: 'cancelled_executions', outcome: 'cancelled', icon: 'fa-ban' },
  { metric: 'failed_executions', outcome: 'failed', icon: 'fa-circle-xmark' },
];

export const METRIC_CHARTS: MetricChart[] = [
  {
    metric: 'done_executions',
    title: 'Done executions',
    formatValue: formatCount,
    integerTicks: true,
    outcome: 'done',
  },
  {
    metric: 'cancelled_executions',
    title: 'Cancelled executions',
    formatValue: formatCount,
    integerTicks: true,
    outcome: 'cancelled',
  },
  {
    metric: 'failed_executions',
    title: 'Failed executions',
    formatValue: formatCount,
    integerTicks: true,
    outcome: 'failed',
  },
  { metric: 'avg_turns', title: 'Avg turns per execution', formatValue: formatOneDecimal },
  {
    metric: 'avg_execution_duration',
    title: 'Avg execution duration (s)',
    formatValue: formatSeconds,
    unit: ' s',
  },
  {
    metric: 'avg_turn_duration',
    title: 'Avg turn duration (s)',
    formatValue: formatSeconds,
    unit: ' s',
  },
];

/** Sum of a series over the period; buckets without a value count as zero. */
export const total = (values: (number | null)[] | undefined): number =>
  (values ?? []).reduce<number>((sum, value) => sum + (value ?? 0), 0);
